export const CheckInAnnounceCard = () => {
  const noteLabel = 'ご予約後の流れにつきまして';
  const noteText = [
    'ご入力内容の確認のために、サポートセンター担当者よりお電話にてご連絡をさせていただく場合がございます。',
    '保険のご利用をお考えの場合は、お手元に保険証書をご用意ください。',
  ];

  return (
    <div className={'check-in-reserve-note-card'}>
      <div className={'note-header'}>
        <div className={'header-icon'}>
          <i className={'icon-image'} />
        </div>
        <div className={'header-label'}>
          <span>{noteLabel}</span>
        </div>
      </div>
      <div className={'note-body'}>
        <ul>
          {noteText.map((text, idx) => (
            <li key={idx}>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
